import $http from '../api/http'

const settings = {
  // 获取操作token列表
  async getApiTokens (data) {
    return $http('/api/tokens', {
      method: 'GET',
      params: data
    });
  },
  // 创建新的操作token
  async setApiToken (params) {
    return $http('/api/tokens', {
      method: 'POST',
      data: { ...params }
    });
  },
  async getWhiteList (params) {
    return $http('/api/users/ip', {
      method: 'GET'
    });
  },
  async updateWhiteList (params) {
    return $http('/api/users/ip', {
      method: 'POST',
      data: { ...params }
    });
  },
  async resetVerifyCode () {
    return $http('/api/tokens/resetVerifyCode', {
      method: 'POST'
    });
  },
  async resetToken (params) {
    return $http('/api/tokens/resetToken', {
      method: 'POST',
      data: {...params}
    })
  }
};

export default settings;



// WEBPACK FOOTER //
// ./src/api/settings.js